import {Record} from 'immutable';

const Course = Record({
    id: null,
    name: null,
    serial: null,
});

export default Course;



// WEBPACK FOOTER //
// src/domain/Course.js